'use strict';

var util = require('../../util'),
	shipping = require('./shipping'),
	formPrepare = require('./formPrepare'),
	formFields = require('./../../components/formFields'),
	applepay = require('./apple_pay');
/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address');
    // Following code sets the value of useAsBillingAddress when user comes back on shipping through Edit Shipping
	var $useAsBillingAddress = $('input[name$="_useAsBillingAddress"]');
    if ($useAsBillingAddress.is(':checked')) {
    	$useAsBillingAddress.val("true");
	} else {
		$useAsBillingAddress.val("false");
	}
    // select address from list
    $('select[name$="_addressList"]', $form).off('change').on('change', function () {
		var addressObj = {};
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        var isdefault = $(selected).data('isdefault');
        addressObj = selectedAddress;
        if( isdefault != undefined ){
        	addressObj.isdefault = isdefault;
        }
        $('.edit-section').removeClass('hide');
        $('.save-section').addClass('hide');
        if( $('.selected-details').length > 0 && $(window).width() < 768){
    		$('.selected-details').show();
    	}
        if (!selectedAddress) {
        	$('.fieldsection').show();
        	$('.fieldsection label').removeClass('input-focus');
        	$('.fieldsection').find('.form-row.country label').addClass('input-focus');
        	$('.edit-section').addClass('hide');
        	$('.selectpayment').addClass('hide');
            if( $('.selected-details').length > 0 && $(window).width() < 768){
        		$('.selected-details').hide();
        	}
        	$('.fieldsection').find('input').val('');
        	$('.fieldsection').find('select:not(.country)').val('');
        	$('.savesection').show();
        	$('.actionsection').hide();
        	$('.checkout-shipping .saved-address-block .required-field').removeClass('hide');    
        	util.inputfocusEvent();
        	//When changing address selection, deselect "default address", "add to address book", and "billing address" check boxes.
        	$('[name$="shippingAddress_makeDefaultAddress"]').prop('checked', false);
			$('[name$="shippingAddress_addToAddressBook"]').prop('checked', false);
			$('[name$="shippingAddress_useAsBillingAddress"]').prop('checked', false);
        	if ( $('.checkout-shipping').length > 0 ) {
	        	formPrepare.init({
	                continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
	                formSelector:'[id$="singleshipping_shippingAddress"]'
	            });
        	} else {
        		formPrepare.init({
	                continueSelector: '[name$="selectpaymentmethod"],[name$="submit_form"],[name$="_billing_saveAddress"]',
	                formSelector: 'form[id$="billing"]'
	            });
        	}
        	return;
        } else {
        	$('.fieldsection').hide();
        	$('.selectpayment').removeClass('hide');
        	$('.savesection').hide();
        	$('.actionsection').show();
        	//SM-6021 In case of changing address selection, removed selected make default address and add to address book check boxes.
        	if( isdefault !== undefined && isdefault !== '' ){
        		$('[name$="shippingAddress_makeDefaultAddress"]').prop('checked', true);
            	$('[name$="shippingAddress_addToAddressBook"]').prop('checked', true);
            } else {
            	$('[name$="shippingAddress_makeDefaultAddress"]').prop('checked', false);
            	$('[name$="shippingAddress_addToAddressBook"]').prop('checked', false);
            }
        	$('.checkout-shipping .saved-address-block .required-field').addClass('hide');
        }
        util.fillAddressFields(addressObj, $form);
        shipping.updateShippingMethodList();
        if ( $('.checkout-shipping').length > 0 ) {
        	$('.address').find('input[name$="_addressFields_address1"], input[name$="_addressFields_address2"]').trigger('change');
        	formPrepare.init({
                continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
                formSelector:'[id$="singleshipping_shippingAddress"]'
            });
    	} else {
    		formPrepare.init({
                continueSelector: '[name$="selectpaymentmethod"],[name$="submit_form"],[name$="_billing_saveAddress"]',
                formSelector: 'form[id$="billing"]'
            });
    	}
        // re-validate the form
        //$form.validate().form();
    });

    $(".select-address .address-dropdown" ).change(function() {
    	var selected = $(this).children(':selected').first();
        var addressID = selected.val();

        //Execute only for shipping address change and should be express checkout scenario.
        if( $('.spc-express-checkout').length > 0  && $(this).closest('.checkout-tab.shipping').length > 0){
        	if(addressID != null && addressID){
        		shipping.updateShippingAddressDetails(addressID);
        		util.refreshBillingSection = true;
			}
        }

        //Execute only for billing address change
    	if( $('.checkout-billing').length > 0 || ($('.spc-express-checkout').length > 0 && $(this).closest('.checkout-tab.billing').length > 0)){
	        if(addressID != null && addressID && !$(this).hasClass('address-cancelled')){		//Fix for SM-5462
				util.validateForPLCCAddress(addressID);
			}
    	}
    	$(this).removeClass('address-cancelled');
    	util.inputfocusEvent();
    });

    $(".address-actions .editaddress" ).on('click', function() {
    	util.inputfocusEvent();
	});

    //Add new address from Shipping page
    $('.shipping-add-new', $form).on('click keypress', function (e) {
			if( !e.isTrigger && e.which != 1 && e.which != 13 ){
				return;
			}
			$('.saved-address-count').addClass('hide');
    	$(this).closest($form).find('.address-dropdown').val("").change();
    	if( $('.selected-details').length > 0 && $(window).width() < 768 ){
    		$('.selected-details').hide();
    	}
    	$('.edit-section').addClass('hide');
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) {
        	$('.fieldsection').removeClass('hide');
            $('.fieldsection label').removeClass('input-focus');
            $('.fieldsection .custom-select').each(function(){              // applies proper label placement to select inputs that have a selected option
                if($(this).find("select").val() != "")
                    $(this).closest('.form-row').find('label').addClass('input-focus');
            });
        	$('.fieldsection').find('input').val('');
        	$('.fieldsection').find('select').val('');
        	$('.fieldsection').find('input, select').removeClass("error").closest(".form-row").removeClass("error-handle");
        	$('.fieldsection').find('select[id$="_country"]').val('US');
        	$('.fieldsection').find('[name$="country"]').trigger('change');
        	util.inputfocusEvent();
        	if ( $('.checkout-shipping').length > 0 ) {
	        	formPrepare.init({
	                continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
	                formSelector:'[id$="singleshipping_shippingAddress"]'
	            });
        	} else {
        		formPrepare.init({
	                continueSelector: '[name$="selectpaymentmethod"],[name$="submit_form"],[name$="_billing_saveAddress"]',
	                formSelector: 'form[id$="billing"]'
	            });
        	}
        	return;
        } else {
        	$('.fieldsection').addClass('hide');
        }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        if ( $('.checkout-shipping').length > 0 ) {
        	formPrepare.init({
                continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
                formSelector:'[id$="singleshipping_shippingAddress"]'
            });
    	} else {
    		formPrepare.init({
                continueSelector: '[name$="selectpaymentmethod"],[name$="submit_form"],[name$="_billing_saveAddress"]',
                formSelector: 'form[id$="billing"]'
            });
    	}
        $('.checkout-shipping .saved-address-block .required-field').removeClass('hide');
        // re-validate the form
        $form.validate().form();
    });

    /**
     *Check save address checkbox and disable it if make default address
     *checkbox is checked in Shipping page.
    */
    $('input[name$="_useAsBillingAddress"]').on('change', function () {
    	if($(this).is(':checked')){
    		$(this).val("true");
    	} else{
    		$(this).val("false");
    	}
    });

    var $defaultAddress = $('input[name$="_makeDefaultAddress"]');
    $defaultAddress.on('change', function () {
    	var $addtoAddress = $('input[name$="_addToAddressBook"]');
		if($defaultAddress.prop('checked')) {
			$addtoAddress.prop('checked', true);
			$addtoAddress.val("true");
			$defaultAddress.val("true");
			$addtoAddress.prop('disabled', true);
		}
		if(!($defaultAddress.prop('checked'))) {
			$defaultAddress.val("false");
			$addtoAddress.prop('disabled', false);
			$addtoAddress.val("false");
			$addtoAddress.prop('checked', false);
		}
    });

    /**
     *Make default functionality to save new payment card.
     *
    */
    var $defaultPayment = $('input[name$="_creditCard_makeDefault"]');
    $("body").off('change','input[name$="_creditCard_makeDefault"]').on('change','input[name$="_creditCard_makeDefault"]',function () {
    	var $saveCard = $('input[name$="_creditCard_saveCard"]');
    	if($defaultPayment.prop('checked')) {
    		$defaultPayment.val("true");
    		$saveCard.val("true");
    		$saveCard.prop('checked', true);
    		$saveCard.attr('checked', "checked");
    		$saveCard.prop('disabled', true);
    	} else if(!($defaultPayment.prop('checked'))) {
    		$saveCard.prop('disabled', false);
    		$defaultPayment.val("false");
		}
    });

    $("body").off('change','input[name$="_creditCard_saveCard"]').on('change','input[name$="_creditCard_saveCard"]',function () {
    	if($(this).is(':checked')) {
    		$(this).val("true");
    	} else {
    		$(this).val("false");
		}
    });

    /**
     * Pass input value as true when user check the save this address checkbox
     *
    */
    $('input[name$="_addToAddressBook"]').on('click',function() {
    	if($(this).is(':checked')){
    		$(this).val("true");
    	} else{
    		$(this).val("false");
    	}
    });

	if( $('input[name$="_makeDefaultAddress"]').prop('checked') ){          
		$('input[name$="_addToAddressBook"]').prop('checked', true);
		$('input[name$="_addToAddressBook"]').val("true");
    }
	
    if ($('.feature-action').val() == 'editaddress') {
		$('.edit-section .shipping-add-edit').trigger('click');
	} else if ($('.feature-action').val() == 'addaddress'){
		$('.shipping-add-new').trigger('click');
	}
	// WCAG - removed aria-required from DIV element
	formFields.init();
	applepay.init();
};
